import { schema } from 'normalizr'

export const pdSchema = new schema.Entity('pd')
